// Maps a notification's entity_type + the current user's role to the page it
// should open on click. Notifications created before entity_type/entity_id
// existed (or ones with no matching route for a role) resolve to null —
// callers should just skip navigation in that case.

const ROLE_SEGMENTS = {
    manager: "manager",
    hr: "hr",
    "team lead": "team-lead",
    approver: "approver",
    employee: "employee",
};

const getRoleSegment = (userType) => ROLE_SEGMENTS[(userType || "").toLowerCase()] || "employee";

export const getNotificationPath = (notification, userType) => {
    const { entity_type: entityType, entity_id: entityId, type: notificationType } = notification || {};
    if (!entityType || !entityId) return null;

    const role = getRoleSegment(userType);

    switch (entityType) {
        case "task":
            if (role === "employee") return `/employee/my-tasks-details?taskId=${entityId}`;
            if (role === "manager" || role === "team-lead") return `/${role}/user-task-details?taskId=${entityId}`;
            return null;

        case "project":
            if (role === "manager" || role === "team-lead") return `/${role}/projects/edit?projectId=${entityId}`;
            if (role === "employee") return "/employee/my-project-list";
            return null;

        case "timesheet":
            if (role === "manager") return `/manager/timesheet-management/${entityId}`;
            if (role === "hr") return `/hr/timesheet-management/${entityId}`;
            if (role === "team-lead") return `/team-lead/my-timesheet/${entityId}`;
            if (role === "approver") return "/approver/timesheet-management";
            if (role === "employee") return "/employee/my-timesheets";
            return null;

        case "leave": {
            // "Leave Request" = someone's leave is awaiting this user's action -> team approval page.
            // "Leave Approval" = a status update on a leave (often the user's own) -> personal leave page.
            const needsApproval = notificationType === "Leave Request";
            if (role === "manager") return needsApproval ? "/manager/leave-management" : "/manager/manage-leave-requests";
            if (role === "team-lead") return needsApproval ? "/team-lead/leave-management" : "/team-lead/manage-leave-requests";
            if (role === "hr") return "/hr/leave-management";
            if (role === "employee") return "/employee/manage-leave-requests";
            return null;
        }

        default:
            return null;
    }
};
